import React, {Component} from 'react';
import Stepper from './Stepper';

class MakeupServices extends Component {
    constructor(props) {
        super(props)
        this.activePopupHair = this.activePopupHair.bind(this);
        this.templateServices = this.templateServices.bind(this);
    }

    activePopupHair() {
        this.props.handlePopupMakeup(true)
    }

    templateServices(service) {
        if (service.kind === 'Makeup Services') {
            return (
                <div className="priceblock">
                    <div className="fieldttitle">{service.title} ${service.price}</div>
                    <Stepper
                        handleStepChange={this.props.handleStepChange.bind(this, service.id)}
                        validField={this.props.validField}
                    />
                </div>
            )
        }
    }
    render(){
        let services = this.props.services;

        return(
            <div className="frm-row">
                <div className="section colm colm12">
                    <div className="spacer-b20">
                        <div className="tagline">
                                                    <span>Makeup Services <a href="#"
                                                                             className="openSlickModal-2 manualLabel"
                                                                             onClick={this.activePopupHair}
                                                    >Learn More</a></span>
                        </div>
                        <div className="qtytxt">Quantity</div>
                    </div>
                    {
                        services.map(this.templateServices)
                    }
                </div>
            </div>
        )
    }
}

export default MakeupServices;




/** WEBPACK FOOTER **
 ** ./src/components/MakeupServices.js
 **/